<template>
  <OfferComparisonCard
    :benefits
    dialog-name="us-telco-comparators-noble-mobile"
    :name="i18n(translations.name)"
    price="$50.00"
    :trustpilot-rating="4.5"
  >
    <template #logo>
      <RevIllustration
        alt=""
        class="size-32 shrink-0"
        :height="32"
        src="/img/noble/noble-logo-tiny-white.svg"
        :width="32"
      />
    </template>

    <template #info>
      <RevInfoBlock
        :content="i18n(translations.promoContent)"
        :icon="IconPriceTag"
        :title="i18n(translations.promoTitle)"
        variant="success"
      />
    </template>

    <template #modal>
      <div class="space-y-24">
        <RevIllustration
          alt=""
          :height="144"
          image-class-names="w-full h-auto"
          src="/img/telco-partnership/noble-cobranded.png"
          :width="491"
        />

        <ModalStepsList :steps="modalSteps" />

        <RevButton
          full-width="always"
          target="_blank"
          :to="i18n(translations.modalCtaLink)"
          variant="primary"
        >
          <span class="flex items-center gap-4">
            {{ i18n(translations.modalCtaLabel) }}
            <IconExternalLink size="medium" />
          </span>
        </RevButton>
      </div>
    </template>
  </OfferComparisonCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconExternalLink } from '@ds/icons/IconExternalLink'
import { IconPriceTag } from '@ds/icons/IconPriceTag'

import OfferComparisonCard from '../OfferComparisonCard/OfferComparisonCard.vue'
import ModalStepsList from '../OfferComparisonCard/components/ModalStepsList/ModalStepsList.vue'

import translations from './NobleMobileOfferCard.translations'

const i18n = useI18n()

const benefits = computed(() => [
  i18n(translations.benefitNetwork),
  i18n(translations.benefitUnlimited),
  i18n(translations.benefitMoneyBack),
])

const modalSteps = computed(() => [
  i18n(translations.modalStep1),
  i18n(translations.modalStep2),
  i18n(translations.modalStep3),
])
</script>
